// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popupcontainers {
  box-sizing: border-box;
  background: #ffffff;
  border: 1px solid #aeb4c1;
  border-radius: 6px;
  padding: 1rem;
  width: 51.88vw;
  position: fixed;
  top: 7%;
  left: 25%;
}
.popupcontainers .popup_containers {
  display: flex;
  justify-content: center;
  align-items: center;
}
.popupcontainers .poupfirst_para {
  display: flex;
  justify-content: space-between;
  width: 96%;
  margin: 1rem;
}
.popupcontainers .poupfirst_para > span {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  color: #0c3688;
}
.popupcontainers .poupfirst_para > img {
  width: 14px;
  height: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.popupcontainers .poupsecond_para {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  color: #32363f;
  width: 80%;
  margin: 1rem;
}
.popupcontainers .poupthird_para {
  display: flex;
  justify-content: flex-start;
  margin: 1rem;
  border-bottom: 1px solid #A3AEC4;
  gap: 2rem;
}
.popupcontainers .profiledetailspgm:active {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 16px !important;
  line-height: 25px;
  color: #0c3688;
  border-bottom: 3px solid #0C3688;
}
.popupcontainers .profiledetailspgm:active {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 16px !important;
  line-height: 25px;
  color: #0c3688;
  border-bottom: 3px solid #0C3688;
}
.popupcontainers .profiledetailspgm {
  cursor: pointer;
}
.popupcontainers .dark_color {
  color: #0C3688;
  font-weight: bolder;
  border-bottom: 3px solid #0C3688;
}
.popupcontainers .profiledetails {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 25px;
  color: black;
}
.popupcontainers .poupfourth_para {
  background: #eef1f5;
  border-radius: 6px;
  margin: 1rem;
}
.popupcontainers .poupcommercial {
  width: 94%;
  margin: 0rem 1rem;
  padding: 0.4rem 0rem;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
.popupcontainers .scroll-div {
  width: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
  height: 55vh;
}
.popupcontainers .circlediv_s {
  display: flex;
  gap: 0.5rem;
}
.popupcontainers .circle_dot {
  height: 10px;
  width: 10px;
  background-color: black;
  border-radius: 50%;
  display: inline-block;
  margin: 0.3rem 0rem;
}
.popupcontainers .span_special_text {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  color: #2D2D2D;
}
.popupcontainers .Popup_input {
  display: flex;
  justify-content: space-between;
}
.popupcontainers .poupcommercialinput {
  width: 10px;
  color: black;
  background: red;
  margin: -0.4rem 0rem;
}
.popupcontainers .crossiconred {
  width: 14px;
  height: 14px;
  float: right;
  margin: 0.5rem;
}
.popupcontainers .input_filedspopup {
  background: #ffffff;
  border: 1px solid #aeb4c1;
  border-radius: 6px;
  height: 3.5rem;
  margin: 1rem 0rem;
  width: 100%;
}
.popupcontainers .inputdiv {
  margin: -1rem 0rem;
}
.popupcontainers .Popup_buttons {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  gap: 1rem;
}
.popupcontainers .Popup_buttons_cancel {
  height: 30px;
  background: linear-gradient(277.62deg, #0C3688 10%, #2057C2 84.88%);
  border-radius: 5px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  color: #FFFFFF;
}
.popupcontainers .Popup_buttons_submit {
  height: 30px;
  background: #BA1A1A;
  border-radius: 5px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  color: #FFFFFF;
}
.popupcontainers .Securityquestion_text {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  display: flex;
  color: #32363F;
}
.popupcontainers .loader-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 4vh !important;
}
.popupcontainers .loader-container .loader {
  border: 3px solid #f3f3f3;
  border-top: 3px solid #3498db;
  border-radius: 50%;
  width: 25px;
  height: 25px;
  animation: spin 2s linear infinite;
}`, "",{"version":3,"sources":["webpack://./src/component/Poppup/popup.scss"],"names":[],"mappings":"AACA;EACE,sBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;EACA,OAAA;EACA,SAAA;AAAF;AAEA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAAF;AAGA;EACE,aAAA;EACA,8BAAA;EACA,UAAA;EACA,YAAA;AADF;AAGA;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AADF;AAGA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AADF;AAGA;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,UAAA;EACA,YAAA;AADF;AAGA;EACE,aAAA;EACA,2BAAA;EACA,YAAA;EACA,gCAAA;EACA,SAAA;AADF;AAGA;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,0BAAA;EACA,iBAAA;EACA,cAAA;EACA,gCAAA;AADF;AAGA;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,0BAAA;EACA,iBAAA;EACA,cAAA;EACA,gCAAA;AADF;AAGA;EACE,eAAA;AADF;AAGE;EACA,cAAA;EACA,mBAAA;EACA,gCAAA;AADF;AAGA;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;AADF;AAIA;EACE,mBAAA;EACA,kBAAA;EACA,YAAA;AAFF;AAIA;EACE,UAAA;EACA,iBAAA;EACA,oBAAA;EACA,aAAA;EACA,8BAAA;EACA,sBAAA;AAFF;AAIA;EACE,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;AAFF;AAKA;EACE,aAAA;EACA,WAAA;AAHF;AAKA;EACE,YAAA;EACA,WAAA;EACA,uBAAA;EACA,kBAAA;EACA,qBAAA;EACA,mBAAA;AAHF;AAMA;EACE,qBAAA;EACF,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAJA;AAMA;EACE,aAAA;EACA,8BAAA;AAJF;AAOA;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,oBAAA;AALF;AAOA;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,cAAA;AALF;AAOA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,WAAA;AALF;AAQA;EACE,kBAAA;AANF;AAQA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;AANJ;AAQA;EACI,YAAA;EACA,mEAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AANJ;AAQA;EACI,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AANJ;AAQA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,cAAA;AANA;AAQA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AANF;AAOE;EACE,yBAAA;EACA,6BAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kCAAA;AALJ","sourcesContent":["\n.popupcontainers {\n  box-sizing: border-box;\n  background: #ffffff;\n  border: 1px solid #aeb4c1;\n  border-radius: 6px;\n  padding: 1rem;\n  width: 51.88vw;\n  position: fixed;\n  top: 7%;\n  left: 25%;\n\n.popup_containers{\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  \n}\n.poupfirst_para {\n  display: flex;\n  justify-content: space-between;\n  width: 96%;\n  margin: 1rem;\n}\n.poupfirst_para > span {\n  font-family: \"Nunito\";\n  font-style: normal;\n  font-weight: 600;\n  font-size: 20px;\n  color: #0c3688;\n}\n.poupfirst_para > img {\n  width: 14px;\n  height: 14px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n}\n.poupsecond_para {\n  font-family: \"Nunito\";\n  font-style: normal;\n  font-weight: 700;\n  font-size: 14px;\n  color: #32363f;\n  width: 80%;\n  margin: 1rem;\n}\n.poupthird_para {\n  display: flex;\n  justify-content: flex-start;\n  margin: 1rem;\n  border-bottom: 1px solid #A3AEC4;\n  gap: 2rem;\n}\n.profiledetailspgm:active {\n  font-family: \"Nunito\";\n  font-style: normal;\n  font-weight: 700;\n  font-size: 16px !important;\n  line-height: 25px;\n  color: #0c3688;\n  border-bottom: 3px solid #0C3688;\n}\n.profiledetailspgm:active {\n  font-family: \"Nunito\";\n  font-style: normal;\n  font-weight: 700;\n  font-size: 16px !important;\n  line-height: 25px;\n  color: #0c3688;\n  border-bottom: 3px solid #0C3688;\n}\n.profiledetailspgm{\n  cursor: pointer;\n  }\n  .dark_color{\n  color: #0C3688;\n  font-weight: bolder;\n  border-bottom: 3px solid #0C3688;\n  }\n.profiledetails {\n  font-family: \"Nunito\";\n  font-style: normal;\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 25px;\n  color: black;\n}\n\n.poupfourth_para {\n  background: #eef1f5;\n  border-radius: 6px;\n  margin: 1rem;\n}\n.poupcommercial {\n  width: 94%;\n  margin: 0rem 1rem;\n  padding: 0.4rem 0rem;\n  display: flex;\n  justify-content: space-between;\n  flex-direction: column;\n}\n.scroll-div{\n  width: 100%;\n  overflow-x: hidden;\n  overflow-y: scroll;\n  height: 55vh;\n}\n\n.circlediv_s{\n  display: flex;\n  gap: 0.5rem;\n}\n.circle_dot{\n  height: 10px;\n  width: 10px;\n  background-color: black;\n  border-radius: 50%;\n  display: inline-block;\n  margin: 0.3rem 0rem;\n  \n}\n.span_special_text{\n  font-family: 'Nunito';\nfont-style: normal;\nfont-weight: 600;\nfont-size: 14px;\ncolor: #2D2D2D;\n}\n.Popup_input {\n  display: flex;\n  justify-content: space-between;\n  \n}\n.poupcommercialinput {\n  width: 10px;\n  color: black;\n  background: red;\n  margin: -0.4rem 0rem;\n}\n.crossiconred {\n  width: 14px;\n  height: 14px;\n  float: right;\n  margin: 0.5rem;\n}\n.input_filedspopup {\n  background: #ffffff;\n  border: 1px solid #aeb4c1;\n  border-radius: 6px;\n  height: 3.5rem;\n  margin: 1rem 0rem;\n  width: 100%;\n\n}\n.inputdiv{\n  margin: -1rem 0rem;\n}\n.Popup_buttons{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n    gap: 1rem;\n}\n.Popup_buttons_cancel{\n    height: 30px;\n    background: linear-gradient(277.62deg, #0C3688 10%, #2057C2 84.88%);\n    border-radius: 5px;\n    font-family: 'Nunito';\n    font-style: normal;\n    font-weight: 700;\n    font-size: 16px;\n    color: #FFFFFF;\n}\n.Popup_buttons_submit{  \n    height: 30px;\n    background: #BA1A1A;\n    border-radius: 5px;\n    font-family: 'Nunito';\n    font-style: normal;\n    font-weight: 700;\n    font-size: 16px;\n    color: #FFFFFF;\n}\n.Securityquestion_text{\nfont-family: 'Nunito';\nfont-style: normal;\nfont-weight: 400;\nfont-size: 14px;\ndisplay: flex;\ncolor: #32363F;          \n}\n.loader-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 4vh !important;\n  .loader {\n    border: 3px solid #f3f3f3;\n    border-top: 3px solid #3498db;\n    border-radius: 50%;\n    width: 25px;\n    height: 25px;\n    animation: spin 2s linear infinite;\n}\n}\n}       "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
